// extracted by mini-css-extract-plugin
module.exports = {"Content":"CookieBanner_Content__39B9c","Buttons":"CookieBanner_Buttons__1KWu6"};